import React, { Dispatch, SetStateAction, useMemo } from "react";
import useLocalStorage from "../../../CustomHooks/useLocalStorage";

export const FavoriteContext = React.createContext<[number[], Dispatch<SetStateAction<number[]>>]|null>(null);

interface Props {
    children: React.ReactNode;
}

export function FavoriteContextProvider({children}: Props) {
    const [favorites, setFavorites] = useLocalStorage<number[]>("favorites", []);

    // Entfernt Duplikate, die durch einen früheren Bug in favorites landen konnten,
    // ohne dass Nutzer ihre gespeicherten Favoriten manuell bereinigen müssen.
    const dedupedFavorites = useMemo(() => Array.from(new Set(favorites)), [favorites]);

    return (
        <FavoriteContext.Provider value={[dedupedFavorites, setFavorites]}>
            {children}
        </FavoriteContext.Provider>
    );
}
